import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizState } from ".";

export interface IAbortQuizResponse {};

export const abortQuiz = createAsyncThunk<IAbortQuizResponse>(
    'quiz.abortQuiz',
    async () => await api.quizzes.abort()
);

const abortQuizHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(abortQuiz.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(abortQuiz.fulfilled, (state: IQuizState) => {
            state.loading = false;            
            state.quiz = null;
            state.answerResult = null;
            state.isExpired = false;
        })
        .addCase(abortQuiz.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to abort quiz';
        });
};

export default abortQuizHandler;